import { api } from '../config/base-api';
import { GetGiftsResponse, NormalizedGetGiftsResponse } from 'types';
import { normalizeGiftItems } from 'utils/giftSelection';

export async function getGifts(
  planId: string,
  isServer = false
): Promise<NormalizedGetGiftsResponse> {
  const requestUrl = isServer
    ? `http://localhost:3000/api/v1/gifts/${planId}`
    : `/api/v1/gifts/${planId}`;

  const res = await api.get<GetGiftsResponse>(requestUrl);

  return {
    gifts: normalizeGiftItems(res.data || []),
  };
}
